import React from 'react';
import '../../css/views/CaseDetail.scss';
import { FhirClientContext } from '../../FhirClientContext';
import { withTranslation } from 'react-i18next';
import Communication from './Communication';


/**
 * Wraps everything into `FhirClientProvider` so that any component
 * can have access to the fhir client through the context.
 */
class CommunicationList extends React.Component {
  static contextType = FhirClientContext;

  constructor(props) {
    super(props);
  }

  componentWillUnmount() {}

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          'communicationList ' +
          (this.props.isReadOnly ? 'readOnlyHeight' : this.props.showVideoconf ? 'videoConfHeight' : 'normalHeight')
        }
      >
        {this.props.communications.map(item => (
          <Communication
            key={item.id}
            id={item.id}
            item={item}
            sr_id={this.props.sr_id}
            srRequester={this.props.srRequester}
            setVideoconferenceLink={this.props.setVideoconferenceLink}
            setVideoconferenceActive={this.props.setVideoconferenceActive}
            onJoinVideoconferenceButtonClick={this.props.onJoinVideoconferenceButtonClick}
            reRender={this.props.reRender}
            addDocRef={this.props.addDocRef}
            addCategoryEntry={this.props.addCategoryEntry}
            addDocumentReferenceData={this.props.addDocumentReferenceData}
            addFullResPicture={this.props.addFullResPicture}
            onSelectImage={this.props.onSelectImage}
          />
        ))}
      </div>
    );
  }
}

export default withTranslation()(CommunicationList);
